// 🟦 = blocked
// ⬜ = selected
// ⬛ = empty
// 🔳 = seat/click

export default {

  '🟦🔳⬜🔳🟦': [
    ({ seat, block }) => block.isBlocked(-1) && block.isBlocked(1) && seat.isEdge(),
    () => ({
      valid: true,
      stop: true,
    })
  ],

  '🟦🔳🔳🔳🟦': [
    ({ seat, block }) => block.isBlocked(-1) && block.isBlocked(1),
    ({ seat }) => ({
      deselect: seat.edge(),
      valid: false,
      stop: true,
    })
  ],

  '🟦🔳🔳⬜⬛': [
    ({ seat, block }) => block.isBlocked(-1) && seat.isNotLast(),
    ({ seat }) => ({
      deselect: seat.last(),
      valid: false,
      stop: true,
    })
  ],

  '⬛⬜🔳🔳🟦': [
    ({ seat, block }) => block.isBlocked(1) && seat.isNotFirst(),
    ({ seat }) => ({
      deselect: seat.first(),
      valid: false,
      stop: true,
    })
  ],

  '⬛⬜🔳⬜⬛': [
    ({ seat }) => seat.isNotEdge(),
    ({ seat }) => ({
      deselect: seat.edge(),
      valid: false,
      stop: true,
    })
  ],

}
